(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }
      hide() {
        super.hide();
        window.pauseAllMedia();
      }
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }
      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    

  function fixedHeaderTransparent() {
    let checkHeaderHeight = setInterval(function(){
      let headerElement = document.querySelector('.section-header');
      let headerFixedElement = headerElement.getElementsByClassName('color-background-transparent');
      
      if(headerFixedElement.length) {
        let headerTopPositionElement = headerElement.offsetHeight;
        if (window.innerWidth > 990) {
          headerElement.style.marginBottom = "-" + headerTopPositionElement + "px";
        } else {
          headerElement.style.marginBottom = "-" + headerTopPositionElement / 2 + "px";
        }
      }
    }, 100);
    setTimeout(() => { 
      clearInterval(checkHeaderHeight);
    }, 8000);
  }

  document.addEventListener('shopify:section:load', fixedHeaderTransparent);
  document.addEventListener('DOMContentLoaded', fixedHeaderTransparent);
  window.addEventListener('resize', fixedHeaderTransparent);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.headerFixed = this.header.getElementsByClassName('color-background-transparent');

      if(this.headerFixed.length){
        this.headerTopPosition = this.header.offsetHeight;
        if (window.innerWidth > 990) {
          this.header.style.marginBottom = "-" + this.headerTopPosition + "px";
        } else {
          this.header.style.marginBottom = "-" + this.headerTopPosition / 2 + "px";
        }
      } 

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      if(this.headerFixed.length){
        this.header.style.top = "0";
      } 
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    
    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if(this.headerFixed.length){
        this.header.style.top = " " + this.headerTopPosition + "px";
      } 
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  function fixedHeaderTransparent() {
    let checkHeaderHeight = setInterval(function(){
      let headerElement = document.querySelector('.section-header');
      let headerFixedElement = headerElement.getElementsByClassName('color-background-transparent');
      
      if(headerFixedElement.length) {
        let headerTopPositionElement = headerElement.offsetHeight;
        if (window.innerWidth > 990) {
          headerElement.style.marginBottom = "-" + headerTopPositionElement + "px";
        } else {
          headerElement.style.marginBottom = "-" + headerTopPositionElement / 2 + "px";
        }
      }
    }, 100);
    setTimeout(() => { 
      clearInterval(checkHeaderHeight);
    }, 8000);
  }

  document.addEventListener('shopify:section:load', fixedHeaderTransparent);
  document.addEventListener('DOMContentLoaded', fixedHeaderTransparent);
  window.addEventListener('resize', fixedHeaderTransparent);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.headerFixed = this.header.getElementsByClassName('color-background-transparent');

      if(this.headerFixed.length){
        this.headerTopPosition = this.header.offsetHeight;
        if (window.innerWidth > 990) {
          this.header.style.marginBottom = "-" + this.headerTopPosition + "px";
        } else {
          this.header.style.marginBottom = "-" + this.headerTopPosition / 2 + "px";
        }
      } 

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      if(this.headerFixed.length){
        this.header.style.top = "0";
      } 
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    
    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if(this.headerFixed.length){
        this.header.style.top = " " + this.headerTopPosition + "px";
      } 
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer-hulkapps-backup"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommendation-products"] && !Shopify.designMode) return;
  try {
    
    function functionSliderRecommendations() {
      const sliderRecommendations = document.querySelector('.slider-recommendations');
      let sliderRecommendationsWidth = window.innerWidth;
      let swiperRecommendations = new Swiper(".slider-recommendations", {
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      });
      if (sliderRecommendationsWidth < 750 && sliderRecommendations) {
        swiperRecommendations.init('.slider-recommendations');
      }
      else {
        swiperRecommendations.destroy(true, true);
      }
    }

    document.addEventListener('DOMContentLoaded', functionSliderRecommendations);
    document.addEventListener('shopify:section:load', functionSliderRecommendations);
    window.addEventListener('resize', functionSliderRecommendations);

  } catch(e) { console.error(e); }
})();
})();
